import React, { useEffect, useState } from 'react';
import MuiTable from '../../../../common-utilities/core/mui-table';
import './index.scss';
import ConfirmModal from '../../../../common-utilities/core/confirm-modal';
import { deleteExtraCharge, loadDepartmentOptions, queryExtraCharges} from './apis';
import HeaderSection from './components/header-section';
import { getHeaderConfig } from './config';
import { modalActions } from './utils';
import CreateUpdateModal from './components/modal.js';

const ExtraCharges = () => {
  const [modalDetails, setModalDetails] = useState({});
  const [tableData, setTableData] = useState({});
  const [departmentList, setDepartmentList] = useState([]);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sortBy: '-createdAt',
  });
  const closeModal = () => {
    setModalDetails({});
  };

  const modalSuccess = () => {
    queryExtraCharges(filters, setTableData, setFilters);
    closeModal();
  };

  useEffect(() => {
    queryExtraCharges(filters, setTableData);
    loadDepartmentOptions(setDepartmentList);
  }, []);

  return (
    <div className="finance-v2-extra-charges-list">
      <HeaderSection
        filters={filters}
        setFilters={setFilters}
        setTableData={setTableData}
        setModalDetails={setModalDetails}
      />
      <MuiTable
        columnsList={getHeaderConfig(departmentList)}
        dataList={tableData?.results || []}
        filters={filters}
        pageCount={tableData?.totalPages}
        onClick={(data, action) => {
          modalActions(data, action, setModalDetails);
        }}
        onChange={() => {
          queryExtraCharges(
            {
              ...filters,
              page: 1,
            },
            setTableData
          );
        }}
      />
      {modalDetails?.type === 'DELETE' && (
        <ConfirmModal
          onYes={() => {
            deleteExtraCharge(modalDetails?.data?.id, () => {
              modalSuccess();
            });
          }}
          onNo={closeModal}
        />
      )}
      <CreateUpdateModal
        showModal={
          modalDetails?.type === 'CREATE' || modalDetails?.type === 'EDIT'
        }
        title={modalDetails?.title}
        closeModal={closeModal}
        data={modalDetails?.data}
        departmentList={departmentList}
        onSuccess={modalSuccess}
      />
    </div>
  );
};

export default ExtraCharges;
